import React from 'react';
import PropTypes from 'prop-types';

import RotateLeft from './img/RotateLeft.svg'
import RotateRight from './img/RotateRight.svg'

export function OrientationControlBlock(props) {
  // const setClassName = () => {
  //   return `${props.className}_status ${
  //     props.gelOrientation === "180" ? 'correct' : 'incorrect'
  //   }`;
  // };

  //const getControl = () => (props.gelOrientation === "180" ? 'Yes' : 'No');

  const inc = () => {

    //if(this.props.solution == null){
      props.incGelOrientation({id: props.id})
    // } else {
    //   this.makeToast(
    //     "WARNING",
    //     "You cannot rotate the gel once buffer has been added to the box.",
    //     "Buffer in gel box!"
    //   );
    // }

  }
  const dec = () => {

    // if(this.props.solution == null){
      props.decGelOrientation({id: props.id})
    // } else {
    //   this.makeToast(
    //     "WARNING",
    //     "You cannot rotate the gel once buffer has been added to the box.",
    //     "Buffer in gel box!"
    //   );
    // }

  }

  return (
    <div className={`${props.className}_block`}>
      <div className="gel-position-controls">
        <p>Rotate the gel</p>
        <button tabIndex={0} onClick={(e)=>inc(e)}><img aria-label="Rotate clockwise" src={RotateLeft} /></button>
        <button tabIndex={0} onClick={(e)=>dec(e)}><img aria-label="Rotate anti-clockwise" src={RotateRight} /></button>
      </div>
    </div>
  );
}

OrientationControlBlock.propTypes = {
  /**
   * ClassName to set on status warning component
   */
  className: PropTypes.string,
  /**
   * Boolean to set the Microcentrifuge Orientationd Control Yes/No
   */
  gelOrientation: PropTypes.int,
};

OrientationControlBlock.defaultProps = {};
